import type { FunctionComponent } from 'react'
import React from 'react'
import { Grid, GridItem, MultiLinkCard, TypographyV2 as Typography } from '@which/seatbelt'

import classNames from 'classnames'

import type { RelatedGuides as RelatedGuidesType } from '../../../../generated/frontend'
import styles from './RelatedGuides.module.scss'

export const RelatedGuides: FunctionComponent<RelatedGuidesProps> = ({ data }) => {
  if (!data?.guides?.length) {
    return null
  }

  return (
    <div data-testid="related-guides" className={classNames(styles.relatedGuidesWrapper)}>
      <Grid className={classNames(styles.relatedGrid, 'w-page-wrapper')}>
        {data?.title && (
          <GridItem span={{ medium: 10, large: 10 }} columnStart={{ medium: 2, large: 2 }}>
            <Typography textStyle="sb-text-heading-medium" className={styles.guidesTitle}>
              Guides related to {data.title}
            </Typography>
          </GridItem>
        )}
        <GridItem
          span={{ medium: 10, large: 10 }}
          columnStart={{ medium: 2, large: 2 }}
          className={styles.relatedGuides}
        >
          {data.guides?.map((guide, index) => (
            <MultiLinkCard
              key={`${guide.heading}-${index}`}
              title={guide.heading}
              links={guide.items}
              viewAllLink={guide.link}
            />
          ))}
        </GridItem>
      </Grid>
    </div>
  )
}

///////// IMPLEMENTATION /////////

type RelatedGuidesProps = {
  data: RelatedGuidesType
}
